/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Tumor from './tumor';
import TumorDetail from './tumor-detail';
import TumorUpdate from './tumor-update';
import TumorDeleteDialog from './tumor-delete-dialog';

const TumorRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Tumor />} />
    <Route path="new" element={<TumorUpdate />} />
    <Route path=":id">
      <Route index element={<TumorDetail />} />
      <Route path="edit" element={<TumorUpdate />} />
      <Route path="delete" element={<TumorDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorRoutes;
